import { getWindowWidth } from "./dom"

const codeToMsg = {
  40005: "邮箱或手机已注册",
  40001: "用户名或密码错误",
  20002: "非法请求，参数缺失/不合法",
}

export function filter (code, error: string) {
  code = String(code)
  error = error || '未知错误'
  return codeToMsg[code] || error.slice(0, 20)
}

export function showMoney (num: number) {
  num = +num
  if (getWindowWidth() <= 767) {
    return `${num.toFixed(0)}`
  }
  return `${num.toFixed(2)}元`
}
